import { isApp } from "@/Utils/Ionic";

export const addTrackersAndCookiesBanner = () => {
  if (!isApp()) {
    // COOKIES AND TRACKERS
  }
};
